import React from 'react';
import { cn } from '@/lib/utils';

/** Italic serif accent with the scroll-driven gold reflection. */
const GoldText = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <span className={cn('gold-shine gold-it', className)}>{children}</span>
);

export default GoldText;
